// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  isLoading?: boolean;
  fullWidth?: boolean;
  leftIcon?: ReactNode;
}

export function Button({
  variant = 'primary',
  isLoading = false,
  fullWidth = false,
  leftIcon,
  children,
  disabled,
  type,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type ?? 'button'}
      className="ds-button"
      data-variant={variant}
      data-full-width={fullWidth}
      disabled={disabled === true || isLoading}
      aria-busy={isLoading}
      {...rest}
    >
      {isLoading ? <span className="ds-spinner" aria-hidden /> : leftIcon}
      <span>{children}</span>
    </button>
  );
}
